import { render } from "./Footer.vue?vue&type=template&id=2f92794f&scoped=true&bindings={}"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2f92794f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f92794f"

export default script